<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 14:01:21
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-01-29 17:07:57
-->
<script lang='ts' setup>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import type { TopicSwiperResponse } from '@/server/types'
import { LOAD_STATE } from '@/shared/types'
import { topicSwiperApi } from '@/server'

const props = withDefaults(defineProps<{ topicId: string }>(), {})

const bannerData = reactive<TopicSwiperResponse>({
  bannerImgLs: [],
  linkTextLs: [],
})
const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
async function getData() {
  const res = await useLoadState({
    key: `专题数据swiper-${props.topicId}`,
    state,
    fn: () => { return topicSwiperApi(props.topicId) },
  })
  if (!res?.data)
    return

  bannerData.bannerImgLs = res.data.bannerImgLs
  bannerData.linkTextLs = res.data.linkTextLs
}
await getData()
</script>

<template>
  <div flex>
    <div class=" w-[calc(100%-478px)]">
      <NCarousel
        show-arrow dot-type="line" effect="fade"
        :default-index="0" :autoplay="true"
        class="flex-shrink-0 h-90 w-162.5 rounded-md mr-sm bg-slate-1"
      >
        <!-- TODO:AD_A4 -->
        <NuxtLink
          v-for="item, index in bannerData.bannerImgLs" :key="index"
          class="flex items-center justify-end h-full relative"
          :to="checkLink(item?.link || null, APP_ROUTER.newsDetail(item.id))"
        >
          <img
            class="h-full w-full object-cover"
            :alt="item.title"
            :src="imageTransform(item.coverImgUrl, { width: 975, height: 540, format: 'jpeg' })"
          >
          <h3 class="title">
            {{ item.title }}
          </h3>
        </NuxtLink>
      </NCarousel>
    </div>
    <div v-if="bannerData.linkTextLs" class="flex-grow min-w-0 text-4 ">
      <NuxtLink
        v-for="(v, i) in bannerData.linkTextLs" :key="i"
        :to="checkLink(v.link || null, APP_ROUTER.newsDetail(v.id))"
        class="block truncate leading-loose  mb-1.25 last:mb-0 hover:text-orange-6 hover:text-orange-6)"
      >
        {{ v.title }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.title {
  --uno: absolute bottom-0 left-0 w-full h-13 pt-3 leading-10  px-4 text-4 truncate;
  --uno: bg-gradient-to-t from-black text-white font-bold;
}
.n-carousel.n-carousel--bottom :deep(.n-carousel__arrow-group) {
--uno: bottom-12.5 hidden md:flex;
.n-carousel__arrow {
  --uno: bg-black bg-opacity-40;
}
}

.n-carousel.n-carousel--bottom :deep(.n-carousel__dots) {
--uno: bottom-12 flex flex items-end;
&.n-carousel__dots--line .n-carousel__dot {
  --uno: w-3.5 h-1.5 rounded-0 m-1 bg-gray-9 bg-opacity-30;

  &:hover {
    --uno: h-2 bg-white;
  }
  &.n-carousel__dot--active {
    --uno: w-5 bg-white;
  }
}
}
</style>
